export default __webpack_public_path__ + "static/heroBg-bbbbdcae45ff18256a74710eb78e7a9d.png";